import Media from 'react-media';
import React from 'react';
import { string, node, oneOfType } from 'prop-types';

import screen from 'utils/screen';

const Mobile = ({ children }) => (
  <Media
    query={screen.max.md}
    render={() => children}
  />
);

Mobile.propTypes = {
  children: oneOfType([node, string]).isRequired,
};

export default Mobile;
